import {api} from './api';


export const getAlarmsApi = (plataforma: string | null): Promise<any> => {
    return api.get('alarme/', {params:{plataforma}}).then(res => res.data.alarms || res.data.alarme).catch(() => [])
}